import React from 'react'

import { Button } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, oneOf, shape, string } from 'prop-types'

import MTCaptcha from 'Utils/MTCaptcha'

function FormSubmit({
  captchaId,
  label,
  errors,
  isCaptchaRequested,
  isSubmitting,
  error = null,
  className = '',
}) {
  return (
    <div className={`discover-form-submit ${className}`}>
      {/* Honeypot: hidden from people and assistive tech, filled in by naive bots. */}
      <div className="discover-form-submit__honeypot" aria-hidden="true">
        <input type="text" name="bot_detector" tabIndex={-1} autoComplete="off" />
      </div>
      {isCaptchaRequested && <MTCaptcha captchaId={captchaId} />}
      {error && (
        <p className="discover-form-submit__error cgt-body-base" role="alert">
          {errors[error]}
        </p>
      )}
      <Button
        type="primary"
        size="large"
        actionType="submit"
        expand
        disabled={isSubmitting}
        customClass="discover-form-submit__button"
      >
        {label}
      </Button>
    </div>
  )
}

FormSubmit.propTypes = {
  captchaId: string.isRequired,
  label: string.isRequired,
  errors: shape({ captcha: string.isRequired, generic: string.isRequired }).isRequired,
  isCaptchaRequested: bool.isRequired,
  isSubmitting: bool.isRequired,
  error: oneOf(['captcha', 'generic']),
  className: string,
}

export default FormSubmit
